import { DisplayPosition } from '@/type/display-position';
// import {
//   CnDepartmentSelect,
//   componentMap as formComponentMap,
// } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '部门选择器',
    componentName: 'CnDepartmentSelect',
    // component: CnDepartmentSelect,
    // formComponent: formComponentMap.CnDepartmentSelect,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getPrototypeList: () => {
        return [
        // getMultipleSetterSnippet(),
        ];
    },
};
